// Copyright (c) 2017 Deere & Company

export const stripUnsafePathCharacters = string => string.replace(/[\\/:"*?<>|]+/g, '');



// WEBPACK FOOTER //
// ./src/shared/services/strip-unsafe.js